import React from "react";

export function PageHeader({
  title,
  description,
  action,
  testid,
}: {
  title: string;
  description?: string;
  action?: React.ReactNode;
  testid?: string;
}) {
  return (
    <div className="mb-8 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between" data-testid={testid}>
      <div>
        <h1 className="font-display text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl">{title}</h1>
        {description && <p className="mt-1.5 text-sm text-slate-500 sm:text-base">{description}</p>}
      </div>
      {action}
    </div>
  );
}
